import React, { Fragment, useEffect } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import DetailMateriContain from '../../../Component/Learning/DetailMateri';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setDetail } from '../../../Features/Learning/Materi/materialSlice';
import { fetchMaterial } from '../../../Features/Learning/Materi/Utils/MateriUtils';
import { handleGetDetailMaterial } from '../../../Component/Learning/Materi/MateriUtils';

const DetailSubMateri = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const detail = useSelector(state => state.Material.detail)
  const filters = useSelector(state => state.Material.filters)

  useEffect(() => {
    if (id) {
      const newFilters = {
        ...filters,
        "filter[id]": id,
        "page": 1,
      };
      dispatch(fetchMaterial(newFilters))
        .then((response) => {
          // Kode yang akan dijalankan setelah fetch sukses
          handleGetDetailMaterial(dispatch, response.payload.data[0], setDetail)
        })
        .catch((error) => {
          // Tangani error jika fetch gagal
          console.error('Error during fetchMaterial:', error);
        });
    }
  } , [id]);
  
  return (
    <Fragment>
      <Breadcrumbs grandparent="Learning" parent="Materi" title="Detail Materi" />
      <DetailMateriContain />
    </Fragment>
  );
};
export default DetailSubMateri;